export function debitReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_DEBIT":            
        case "UPDATE_DEBIT":
            let list = Object.assign({}, state);
            list[payload.credit_id] = payload
        
            return list
            
        case "GET_DEBITS":
            return payload
            
        case "DELETE_DEBIT":
            let list2 = Object.assign({}, state);
            
            delete list2[payload]
            return list2
        default:
            return state;
    }
    
}